// ── SFTP packet types (draft-ietf-secsh-filexfer-02 §3) ────────────
export const SSH_FXP_INIT = 1;
export const SSH_FXP_VERSION = 2;
export const SSH_FXP_OPEN = 3;
export const SSH_FXP_CLOSE = 4;
export const SSH_FXP_READ = 5;
export const SSH_FXP_WRITE = 6;
export const SSH_FXP_LSTAT = 7;
export const SSH_FXP_FSTAT = 8;
export const SSH_FXP_SETSTAT = 9;
export const SSH_FXP_FSETSTAT = 10;
export const SSH_FXP_OPENDIR = 11;
export const SSH_FXP_READDIR = 12;
export const SSH_FXP_REMOVE = 13;
export const SSH_FXP_MKDIR = 14;
export const SSH_FXP_RMDIR = 15;
export const SSH_FXP_REALPATH = 16;
export const SSH_FXP_STAT = 17;
export const SSH_FXP_RENAME = 18;
export const SSH_FXP_READLINK = 19;
export const SSH_FXP_SYMLINK = 20;

// response types
export const SSH_FXP_STATUS = 101;
export const SSH_FXP_HANDLE = 102;
export const SSH_FXP_DATA = 103;
export const SSH_FXP_NAME = 104;
export const SSH_FXP_ATTRS = 105;

// extended
export const SSH_FXP_EXTENDED = 200;
export const SSH_FXP_EXTENDED_REPLY = 201;

// ── Status codes (draft-ietf-secsh-filexfer-02 §7) ─────────────────
export const STATUS_CODE = {
	OK: 0,
	EOF: 1,
	NO_SUCH_FILE: 2,
	PERMISSION_DENIED: 3,
	FAILURE: 4,
	BAD_MESSAGE: 5,
	NO_CONNECTION: 6,
	CONNECTION_LOST: 7,
	OP_UNSUPPORTED: 8,
} as const;

export type StatusCode = (typeof STATUS_CODE)[keyof typeof STATUS_CODE];

export const STATUS_MESSAGE: Record<number, string> = {
	[STATUS_CODE.OK]: 'OK',
	[STATUS_CODE.EOF]: 'End of file',
	[STATUS_CODE.NO_SUCH_FILE]: 'No such file or directory',
	[STATUS_CODE.PERMISSION_DENIED]: 'Permission denied',
	[STATUS_CODE.FAILURE]: 'Failure',
	[STATUS_CODE.BAD_MESSAGE]: 'Bad message',
	[STATUS_CODE.NO_CONNECTION]: 'No connection',
	[STATUS_CODE.CONNECTION_LOST]: 'Connection lost',
	[STATUS_CODE.OP_UNSUPPORTED]: 'Operation unsupported',
};

// ── Open file flags (draft-ietf-secsh-filexfer-02 §6.3) ────────────
export const OPEN_MODE = {
	READ: 0x00000001,
	WRITE: 0x00000002,
	APPEND: 0x00000004,
	CREAT: 0x00000008,
	TRUNC: 0x00000010,
	EXCL: 0x00000020,
} as const;

// ── Attribute flags (draft-ietf-secsh-filexfer-02 §5) ──────────────
export const ATTR_FLAG = {
	SIZE: 0x00000001,
	UIDGID: 0x00000002,
	PERMISSIONS: 0x00000004,
	ACMODTIME: 0x00000008,
	EXTENDED: 0x80000000,
} as const;

// ── SFTP protocol version ──────────────────────────────────────────
export const SFTP_VERSION = 3;

// ── File mode bits for Stats type detection ────────────────────────
export const S_IFMT = 0o170000;
export const S_IFREG = 0o100000;
export const S_IFDIR = 0o040000;
export const S_IFCHR = 0o020000;
export const S_IFBLK = 0o060000;
export const S_IFIFO = 0o010000;
export const S_IFLNK = 0o120000;
export const S_IFSOCK = 0o140000;

// ── Default read chunk size ────────────────────────────────────────
export const DEFAULT_CHUNK_SIZE = 32768;
